import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Check } from 'lucide-react';
export function CreatorSection() {
  const credentials = ['Coach Ontológico Profesional (ICF)', 'Formación en Sanación Energética', 'Escuela Barbara Ann Brennan', 'Maestría en Registros Akáshicos'];
  return <SectionWrapper bgColor="sand" data-id="element-26">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-27">
        <div className="order-2 md:order-1" data-id="element-28">
          <h2 className="text-3xl md:text-4xl text-text mb-8" data-id="element-29">
            Quién creó este método
          </h2>

          <ul className="space-y-4 mb-8" data-id="element-30">
            {credentials.map((cred, index) => <li key={index} className="flex items-center text-text-secondary" data-id="element-31">
                <Check className="w-5 h-5 text-plum mr-3 flex-shrink-0" data-id="element-32" />
                <span data-id="element-33">{cred}</span>
              </li>)}
          </ul>

          <div className="space-y-4 text-text-secondary leading-relaxed" data-id="element-34">
            <p data-id="element-35">
              Después de mucho tiempo de trabajar con personas de alto
              rendimiento, noté un patrón: el éxito profesional no garantizaba
              la paz interna.
            </p>
            <p data-id="element-36">
              Creé ProMind Energy no como una práctica espiritual más, sino como
              un sistema de higiene energética necesario para sostener la
              responsabilidad sin agotarse.
            </p>
            <p className="text-text/80 italic" data-id="element-37">
              ProMind Energy no nació de la teoría. Nació de observar un patrón
              repetido en mujeres altamente responsables.
            </p>
          </div>
        </div>

        <div className="order-1 md:order-2 w-full bg-ivory border border-border-custom overflow-hidden shadow-sm" data-id="element-38">
          <video src="https://cdn.magicpatterns.com/uploads/iQHTN33so69PkoJZQvrHcz/0226.mp4" controls className="w-full h-auto object-cover aspect-video" poster="https://cdn.magicpatterns.com/uploads/iQHTN33so69PkoJZQvrHcz/0226.mp4#t=0.1" // Optional poster frame trick
        data-id="element-39">
            Tu navegador no soporta el elemento de video.
          </video>
        </div>
      </div>
    </SectionWrapper>;
}